import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UpdatesdetailsmodalComponent } from '../updatesdetailsmodal/updatesdetailsmodal.component';
import { Router } from '@angular/router';
import { TranslationService } from '../../service/translation.service';

@Component({
  selector: 'app-update-complaints',
  templateUrl: './update-complaints.component.html',
  styleUrls: ['./update-complaints.component.css']
})
export class UpdateComplaintsComponent {
  updateData: any = {};
  fromPage: string = '';
  constructor(private dialog: MatDialog, private router: Router, public translation: TranslationService) {
    const nav = this.router.getCurrentNavigation();
    this.updateData = nav?.extras?.state?.['data'] || history.state?.data;
    this.fromPage = nav?.extras?.state?.['fromPage'] || history.state?.from;
    // console.log(this.updateData)
  }
  ngOnInit(): void {
    if (performance.navigation.type === 1) {
      if (this.fromPage) {
        this.router.navigateByUrl(this.fromPage)
      }
    }
  }
  openUpdateDialog(element: any) {
    this.dialog.open(UpdatesdetailsmodalComponent, {
      width: '700px',
      data: element
    });
  }

}
